import { Label } from '~/components'
import { twMerge } from '~/lib/utils'

type FieldLabelProps = {
  label: React.ReactNode
  subText?: React.ReactNode
  required?: boolean
} & React.ComponentProps<typeof Label>

export const FieldLabel = ({
  label,
  subText,
  required = false,
  className,
  ...props
}: FieldLabelProps) => {
  return (
    <Label
      className={twMerge('flex cursor-pointer flex-col gap-y-2', className)}
      {...props}
    >
      <div className="flex items-center gap-x-1">
        <span className="text-base text-body-bold">{label}</span>
        {required && (
          <span className="bg-cta px-1 py-0.5 text-xs font-bold text-white">
            必須
          </span>
        )}
      </div>
      {subText && <p className="text-body-s text-textPrimary">{subText}</p>}
    </Label>
  )
}
